import React from 'react';
import styled from 'styled-components';
import { FaBullseye, FaEye, FaHeart } from 'react-icons/fa';

const MissionVisionSection = styled.section`
  padding: 80px 0;
`;

const BoxContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

const InfoBox = styled.div`
  background-color: ${props => props.theme.colors.lightColor};
  padding: 40px 30px;
  border-radius: ${props => props.theme.borders.radius.regular};
  text-align: center;
  box-shadow: ${props => props.theme.shadows.regular};
  transition: ${props => props.theme.transitions.main};
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const IconBox = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.primaryColor};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  margin: 0 auto 20px;
`;

const BoxTitle = styled.h3`
  font-size: ${props => props.theme.fontSizes.xlarge};
  margin-bottom: 15px;
  color: ${props => props.theme.colors.secondaryColor};
`;

const BoxContent = styled.p`
  color: ${props => props.theme.colors.grey[600]};
  line-height: 1.7;
`;

const MissionVision = () => {
  return (
    <MissionVisionSection>
      <div className="container">
        <BoxContainer>
          <InfoBox>
            <IconBox>
              <FaBullseye />
            </IconBox>
            <BoxTitle>Our Mission</BoxTitle>
            <BoxContent>
              To provide comprehensive education and training in structural engineering and design, 
              fostering technical excellence and professional growth among aspiring engineers.
            </BoxContent>
          </InfoBox>
          
          <InfoBox>
            <IconBox>
              <FaEye />
            </IconBox>
            <BoxTitle>Our Vision</BoxTitle>
            <BoxContent>
              To be the leading institution for structural engineering education and research, 
              recognized for producing competent professionals who contribute to the advancement of the field.
            </BoxContent>
          </InfoBox>
          
          <InfoBox>
            <IconBox>
              <FaHeart />
            </IconBox>
            <BoxTitle>Our Values</BoxTitle>
            <BoxContent>
              Excellence, Innovation, Integrity, Practical Learning, and Student Success guide 
              all our initiatives and activities at KALS Academy.
            </BoxContent>
          </InfoBox>
        </BoxContainer>
      </div>
    </MissionVisionSection>
  );
};

export default MissionVision;
